export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7145.4e2d3b3b.jpg";